import React from 'react';


import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import Login from './pages/Login';
import Upload from './pages/Upload';
import MainLayout from './components/MainLayout';
import Home from './pages/Home';
import Dashboar from './pages/Dashboar';
import About from './pages/About';
import Contact from './pages/Contact';
import Properties from './pages/Properties';
import Register from './pages/Register';
import Agric from './pages/Agric';
import Logistics from './pages/Logistics';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import AdminProperties from './pages/admin/Properties';
import Settings from './pages/admin/Profile';
import Profile from './pages/admin/Profile';
import PropertyDetails from './pages/PropertiesDetails';
import SearchResults from './pages/SearchResults';
import OilGas from './pages/OilGas';


const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children:[
       {
        path: "/",
        element: <Home />,
      },
      {
        path: "/About",
        element: <About />,
      },
      {
        path: "/Contact",
        element: <Contact />,
      },
      {
        path: "/properties/:type?",
        element: <Properties />,
      },
      {
        path: "/properties/:type?/:id?",
        element: <PropertyDetails />,
      },
      {
        path: "/properties/search",
        element:<SearchResults />,
      },
      {
        path: "/Agricultural Investment",
        element: <Agric />,
      },
      {
        path: "/Logistics",
        element: <Logistics />,
      },
      {
        path: "/OilandGAs",
        element: <OilGas />,
      },
    
    ]
  },
  {
    element: <AdminLayout />,
    children:[
       {
        path: "/admin/dashboard",
        element: <Dashboard />,
      },
       {
        path: "/admin/properties",
        element: <AdminProperties />,
      },
       
       
       {
        path: "/admin/profile",
        element: <Profile />,
      },
     
    
    ]
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/upload",
    element: <Upload />,
  },
  {
    path: "/dashboar",
    element: <Dashboar />,
  },
  
  
]);



function App() {
  return (
    <>
    <RouterProvider router={router} />
    </>
  );
}

export default App;
